(function () {
  'use strict';

  angular.module('app').component('cancelBooking', cancelBooking());

  function cancelBooking() {
    return {
      bindings: {
        booking: '=',
        onBookingCancelled: '&',
      },
      controller: CancelBookingComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/components/cancel-booking/cancel-booking.component.html',
    };
  }

  CancelBookingComponent.$inject = ['UtilService', 'BookingService'];

  function CancelBookingComponent(UtilService, BookingService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.saveCancelBooking = saveCancelBooking;

    function saveCancelBooking(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      var params = {
        send_email_to_client: false, // pending
        send_email_to_provider: true,
      };

      // console.log(vm.booking);
      // return;

      vm.sendingForm = true;
      BookingService.updateBookingStatus(
        vm.booking,
        'cancelled',
        vm.cancellationReason,
        params
      ).then(function (data) {
        if (!data.errors) {
          // success
          vm.onBookingCancelled({ bookingObj: data });
        }

        vm.sendingForm = false;
      });
    }
  }
})();
